import { EditorsChoiceSectionBase } from '../../../dapp-form/sections/EditorsChoiceSectionBase';
import { MediaUploadWithExisting } from '../../MediaUploadWithExisting';
import type { DashboardDetailsInputChangeEvent, FormState } from '../types';

interface EditorsChoiceSectionProps {
  formData: FormState;
  resolvedEditorsChoiceGraphicUrl: string | null;
  onInputChange: (event: DashboardDetailsInputChangeEvent) => void;
  onSingleFileChange: (
    fieldName: 'dappIcon' | 'banner' | 'editorsChoiceGraphic',
    file: File | null,
  ) => Promise<void>;
  onRemoveExistingGraphic: () => void;
}

export function EditorsChoiceSection({
  formData,
  resolvedEditorsChoiceGraphicUrl,
  onInputChange,
  onSingleFileChange,
  onRemoveExistingGraphic,
}: EditorsChoiceSectionProps) {
  return (
    <EditorsChoiceSectionBase
      headline={formData.editorsChoiceHeadline}
      tag={formData.editorsChoiceTag}
      hasGraphic={Boolean(
        formData.editorsChoiceGraphic || resolvedEditorsChoiceGraphicUrl,
      )}
      onInputChange={onInputChange}
      graphicField={
        <MediaUploadWithExisting
          name="editorsChoiceGraphic"
          label="Graphic"
          description="To visually represent the dApp."
          dimensions="1200x1200px"
          value={formData.editorsChoiceGraphic}
          existingUrl={resolvedEditorsChoiceGraphicUrl}
          onChange={(file: File | null) =>
            onSingleFileChange('editorsChoiceGraphic', file)
          }
          onRemoveExisting={onRemoveExistingGraphic}
          buttonType="add"
          placeholderClassName="size-80 max-w-full"
        />
      }
    />
  );
}
